import { useContext } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { DragAndDropOptionsContext } from '../../ui/drag-and-drop-options-provider';
export const useDragAndDropOptions = () => {
	const context = useContext(DragAndDropOptionsContext);

	if (!context || fg('navx-gsn-dnc-disable-dnd')) {
		return { enabled: false };
	}

	return {
		enabled: context.enabled,
	};
};
